import { useNavigate } from '@remix-run/react';
import { useContext } from 'react';
import { getRouteOption } from '~/data/awards2024/config';
import imageBanner from '~/images/awards2024/banner@2xn.jpg';
import { LoginDialogContext } from '~/signalsAndContext/LoginContext';

export default function Awards2024Banner({ userInfo }:
{ userInfo: BaseUserInfo | null }) {
  const navigate = useNavigate();
  const { setShowLoginDialogState } = useContext(LoginDialogContext);

  /* 立即报名 */
  const signUp = () => {
    if (!userInfo) {
      setShowLoginDialogState(true);
      return;
    }
    navigate('/awards2024/ownAward', getRouteOption());
  };
  return (
    <div className='awards-banner'>
      <img className="awards-banner__figure" src={imageBanner} alt="GWB GAME AWARDS 2024 KV" />
      <h1 className="awards-banner__title">GWB GAME AWARDS 2024</h1>
      <button type="button" className="awards-banner__btn" onClick={signUp}>点击报名</button>
    </div>
  );
}
